import * as tslib_1 from "tslib";
import { parametersEnum } from '../../enums/parameters.enum';
import * as i0 from "@angular/core";
var CryptDataService = /** @class */ (function () {
    function CryptDataService() {
        this.u8array = new Uint8Array(16);
    }
    CryptDataService.prototype.descrypterParameters = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parameters, key, arrayString, _a, _b, _i, key, prueba;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        parameters = Object.keys(parametersEnum);
                        data = JSON.stringify(data);
                        for (key in parameters) {
                            data = data.replaceAll(parameters[key], parametersEnum[parameters[key]]);
                        }
                        arrayString = data.split(/[": ,{}]+/);
                        _a = [];
                        for (_b in arrayString)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        key = _a[_i];
                        if (!arrayString[key].includes('cdJS')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.desencrypdata(arrayString[key].substring(4))];
                    case 2:
                        prueba = _c.sent();
                        data = data.replaceAll(arrayString[key], prueba);
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        console.log('🚀 ~ file: crypt-data.service.ts:31 ~ CryptDataService ~ descrypterParameters ~ data:', data);
                        return [2 /*return*/, JSON.parse(data)];
                }
            });
        });
    };
    CryptDataService.prototype.encryptdata = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encoder, encoderData, cryptoKey, iv, encryptData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        encoder = new TextEncoder();
                        encoderData = encoder.encode(data);
                        return [4 /*yield*/, window.crypto.subtle.importKey('raw', this.u8array, 'AES-GCM', false, ['encrypt'])];
                    case 1:
                        cryptoKey = _a.sent();
                        iv = window.crypto.getRandomValues(new Uint8Array(12));
                        return [4 /*yield*/, window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, cryptoKey, encoderData)];
                    case 2:
                        encryptData = _a.sent();
                        return [2 /*return*/, btoa(String.fromCharCode.apply(String, tslib_1.__spread(iv))) + '.' + btoa(String.fromCharCode.apply(String, tslib_1.__spread(new Uint8Array(encryptData))))];
                }
            });
        });
    };
    CryptDataService.prototype.desencrypdata = function (encrptedData) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var decoder, _a, ivB64, dataB64, iv, data, cryptoKey, decryptData;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        decoder = new TextDecoder();
                        _a = tslib_1.__read(encrptedData.split('.'), 2), ivB64 = _a[0], dataB64 = _a[1];
                        iv = new Uint8Array(Array.from(atob(ivB64), function (c) { return c.charCodeAt(0); }));
                        data = new Uint8Array(Array.from(atob(dataB64), function (c) { return c.charCodeAt(0); }));
                        return [4 /*yield*/, window.crypto.subtle.importKey('raw', this.u8array, 'AES-GCM', false, ['decrypt'])];
                    case 1:
                        cryptoKey = _b.sent();
                        return [4 /*yield*/, window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: iv }, cryptoKey, data)];
                    case 2:
                        decryptData = _b.sent();
                        return [2 /*return*/, decoder.decode(decryptData)];
                }
            });
        });
    };
    CryptDataService.prototype.generateKey = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encoder;
            return tslib_1.__generator(this, function (_a) {
                encoder.encodeInto(this.key, this.u8array.subarray(0));
                return [2 /*return*/];
            });
        });
    };
    CryptDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CryptDataService_Factory() { return new CryptDataService(); }, token: CryptDataService, providedIn: "root" });
    return CryptDataService;
}());
export { CryptDataService };
